import script from "./attendancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./attendancePage.vue?vue&type=script&setup=true&lang=js"

import "./attendancePage.vue?vue&type=style&index=0&id=443beda7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443beda7"]])

export default __exports__